import React from 'react';
import {Container, Row, Col} from 'reactstrap';
import CellularPackage from '../CellularPackage/CellularPackage';

const cellularPackageHolder = (props) => {
  return (

    <div className="cellular-package-holder">
      <div className="packages-wrapper clearfix" style={props.products && props.products.length > 2 ? {textAlign:'right'} : {}}> 
        {     
          props.products && props.products.length > 0 &&  
          props.products.map(function(item, index) {  
            return <CellularPackage data={item} orderEvent={handleOrderEvent} />
          }) 
        }
      </div> 
    </div>

  );


  function handleOrderEvent(data) {    
    const productId = data.contentLink.id;
    props.onSelected(productId)
  }

};

export default cellularPackageHolder;
